export enum LegalGuardianType {
    TUTOR = 'Tutor',
    ATTORNEY_IN_FACT = 'AttorneyInFact',
}
